<template>
    <div>
        <div style="padding:5px 5px 5px 5px">
            <div class="assembly-header">
                <p style="display:inline;float: left;line-height: 22px;">
                    <b>模具列表</b>
                </p>
            </div>
        </div>

        <el-table :data="orderList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="moldTable"
            highlight-current-row>
            <el-table-column type="index" min-width="2%">
            </el-table-column>
            <el-table-column type="selection" min-width="4%" class="checkColumn">
            </el-table-column>

            <el-table-column prop="orderCode" label="订单编号" min-width="12%">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单数量" min-width="8%" align="center">
            </el-table-column>

            <el-table-column prop="productName" label="产品名称" min-width="15%">
            </el-table-column>
            <el-table-column prop="moldCode" label="模具编号" min-width="14%">
            </el-table-column>

            <el-table-column prop="deliveryTime" label="交货日期" min-width="10%">
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="19%">
            </el-table-column>
            <el-table-column prop="assemblyDes" label="装配状态" min-width="8%" fixed="right">
            </el-table-column>

            <el-table-column fixed="right" prop="polishDes" label="抛光状态" min-width="8%">
                <template slot="header">
                    <el-tooltip class="item" effect="light" placement="top" content="抛光状态：待抛光、抛光中、暂停、完成">
                        <span>抛光状态</span>
                    </el-tooltip>
                </template>
            </el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="60">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small" style="color:#6f5499">更改</el-button>
                </template>
            </el-table-column> -->
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="5" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>

        <p></p>
        <div style="padding:5px 5px 5px 5px">
            <div class="assembly-header">
                <p style="display:inline;float: left;line-height: 22px;">
                    <b>试模列表</b>
                </p>
                <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                    <el-button round type="success" @click="openDialog">新增试模</el-button>
                </p>
            </div>
        </div>

        <el-table :data="moldTestList" style="width: 100%">
            <el-table-column type="index" min-width="3%">
            </el-table-column>

            <el-table-column prop="moldCode" label="模具编号" min-width="15%">
            </el-table-column>
            
            <el-table-column prop="testName" label="试模名称" min-width="15%">
            </el-table-column>
            <el-table-column prop="statusDes" label="试模结果" min-width="10%">
            </el-table-column>

            <el-table-column prop="maker" label="试模人" min-width="8%">
            </el-table-column>
            <el-table-column prop="createdTime" label="试模日期" min-width="10%">
            </el-table-column>

            <el-table-column prop="remark" label="试模反馈" min-width="29%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" min-width="10%">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        更改
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="warning" round size="small" v-if="scope.row.status==0">
                        {{ scope.row.status!=0 ? '' : '删除' }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="试模详情" :visible.sync="dialogFormVisible" width="71%" top="7vh">

            <el-form :inline="true" :model="form">
                <el-form-item label="模具编号" required :label-width="formLabelWidth">
                    <el-input v-model="form.moldCode" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>
                
                <el-form-item label="试模名称" required :label-width="formLabelWidth">
                    <el-input v-model="form.testName" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>

                <!-- <el-form-item label="试模日期" required :label-width="formLabelWidth">
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item> -->

                <el-table :data="testBOMList" border style="width: 100%" size="mini">
                    <el-table-column prop="stage" label="项目" width="100">
                        <template inline-template slot-scope="scope">
                            {{scope.row.stageCode}}段
                        </template>
                        
                    </el-table-column>
                    <el-table-column prop="cannonTEMP" label="炮温" width="85">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.cannonTEMP" size="mini"></el-input>
                        </template>
                        
                    </el-table-column>
                    <el-table-column prop="injectionPressure" label="射胶压力" width="100">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.injectionPressure" size="mini"></el-input>
                        </template>
                        
                    </el-table-column>
                    <el-table-column prop="injectionSpeed" label="射胶速度" width="100">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.injectionSpeed" size="mini"></el-input>
                        </template>
                        
                    </el-table-column>
                    <el-table-column prop="injectionTime" label="射胶时间" width="100">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.injectionTime" size="mini"></el-input>
                        </template>
                        
                    </el-table-column>
                    <el-table-column prop="moldTEMP" label="模温" width="85">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.moldTEMP" size="mini"></el-input>
                        </template>
                        
                    </el-table-column>
                    <el-table-column prop="keepPressure" label="保压压力" width="100">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.keepPressure" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="keepPressureSpeed" label="保压速度" width="100">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.keepPressureSpeed" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="keepPressureTime" label="保压时间" width="100">
                        <template inline-template slot-scope="scope" size="mini">
                            <el-input v-model="scope.row.keepPressureTime" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeCement" label="储胶" width="85">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.storeCement" size="mini"></el-input>
                        </template>
                    </el-table-column>
                </el-table>

                <p></p>
                <el-form-item label="试模反馈" label-width="60">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" rows="3" style="width:740px">
                    </el-input>
                </el-form-item>
                <div style="width:130px;display: inline-block;"></div>

                <el-form-item label="试模结果" :label-width="formLabelWidth">
                    <el-radio-group v-model="form.status" style="width: 200px;">
                        <el-radio :label="1">OK</el-radio>
                        <el-radio :label="2">不OK</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- <div style="width:300px;display: inline-block;"></div> -->

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addMoldTest">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "MoldTest",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            orderList: [],
            dialogFormVisible: false,

            statusSearch: 3,
            assemblyProgressSearch: 0,
            orderForm: {
                id: '',
                orderCode: '自动生成',
                orderCount: 1,
                customer: '',
                empList: [],
                salesman: '',
                salesmanId: '',
                productName: '',
                moldCode: '',
                createdTime: '',
                deliveryTime: '',
                status: 0,
                remark: '',
            },
            assemblyProgress: 0,
            polishProgress: 0,
            formLabelWidth: '120px',
            moldCodeDisable: true,
            // assemblyStyle: {
            //     display: 'none'
            // },
            moldTestList: [],
            //polishDialogVisible: false,
            form: {
                id: '',
                moldCode: '',
                //testCode: '',
                testName: '',
                status: 0,
                maker: '',
                createdTime: '',
                remark: '',
            },
            processNameDisable: false,
            statusVisible: false,
            initialTestBOMList:[{
                stageCode:1
            },{
                stageCode:2
            },{
                stageCode:3
            },{
                stageCode:4
            },{
                stageCode:5
            },{
                stageCode:6
            }],
            testBOMList:[],
            pageIndex:0,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        selectClick(selection, row) {
            this.$refs.moldTable.clearSelection()
            this.$refs.moldTable.toggleRowSelection(row)
            this.form.moldCode = row.moldCode
            this.getAllMoldTest()

        },
        rowClick(row) {
            //console.log(row)
            this.$refs.moldTable.clearSelection()
            this.$refs.moldTable.toggleRowSelection(row)
            this.form.moldCode = row.moldCode
            this.getAllMoldTest()

        },
        handleClick(row) {
            // console.log(row);
            this.form.id = row.id
            
            this.form.moldCode = row.moldCode
            this.form.testName = row.testName

            //this.form.createdTime = row.createdTime

            this.form.status = row.status
            this.form.remark = row.remark

            this.testBOMList=row.testBOM

            this.dialogFormVisible = true
        },
        openDialog() {

            if (this.form.moldCode == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择模具订单'
                })
                return
            }

            this.form.id = ''
            //this.form.moldCode = ''
            //this.form.testCode = ''
            this.form.testName = ''

            this.form.status = 0
            this.form.maker = this.userId
            //this.form.createdTime = ''
            this.form.remark = ''
            
            // console.log('-----this.initialTestBOMList')
            // console.log(this.initialTestBOMList)
            
            this.testBOMList=this.initialTestBOMList

            this.statusVisible = false
            this.dialogFormVisible = true
        },
        editClick(row) {
            this.form.id = row.id
            this.form.processName = row.processName
            this.form.status = row.status
            this.form.remark = row.remark

            this.processNameDisable = true
            this.statusVisible = true
            //this.polishDialogVisible = true
        },
        getAllOrder(val) {

            const formData = new FormData()
            formData.append('status', val)
            formData.append('assemblyProgress', this.assemblyProgressSearch)
            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', 5)

            this.$axios({
                method: "post",
                url: "/shiro/mold/order/getAll",
                data:formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.orderList = data.data
                this.total = this.orderList[0].total
                for (let i in this.orderList) {
                    
                    this.orderList[i].deliveryTime = this.$moment(this.orderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.orderList[i].assemblyProgress == 0) {
                        this.orderList[i].assemblyDes = '待装配'
                    } else if (this.orderList[i].assemblyProgress == 1) {
                        this.orderList[i].assemblyDes = '装配中'
                    } else {
                        this.orderList[i].assemblyDes = '完成'
                    }

                    if (this.orderList[i].polishProgress == 0) {
                        this.orderList[i].polishDes = '待抛光'
                    } else if (this.orderList[i].polishProgress == 1) {
                        this.orderList[i].polishDes = '抛光中'
                    } else if (this.orderList[i].polishProgress == 2) {
                        this.orderList[i].polishDes = '暂停'
                    } else {
                        this.orderList[i].polishDes = '完成'
                    }
                }
            })
        },
        addMoldTest() {
            //console.log('addMoldTest')
            //console.log(this.testBOMList)
            this.$axios({
                method: "post",
                url: "/shiro/mold/test/add",
                data: {
                    id: this.form.id,
                    moldCode: this.form.moldCode,
                    //testCode: this.form.testCode,
                    testName: this.form.testName,
                    status: this.form.status,
                    maker: this.form.maker,
                    //createdTime: this.form.createdTime,
                    remark: this.form.remark,
                    testBOM:this.testBOMList,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.dialogFormVisible = false
                //console.log('addProcess')
                //this.gc=999
                this.getAllOrder(this.statusSearch)
                this.getAllMoldTest()
                this.initialTestBOMList=[{stageCode:1},{stageCode:2},{stageCode:3},{stageCode:4},{stageCode:5},{stageCode:6}]
                // console.log('this.initialTestBOMList')
                // console.log(this.initialTestBOMList)
                
            })
        },
        getAllMoldTest() {
            this.$axios({
                method: "post",
                url: "/shiro/mold/test/getAll",
                data: {
                    moldCode: this.form.moldCode,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.moldTestList = data.data
                
                for (let i in this.moldTestList) {

                    this.moldTestList[i].createdTime = this.$moment(this.moldTestList[i].createdTime).format("YYYY-MM-DD")

                    if (this.moldTestList[i].status == 0) {
                        this.moldTestList[i].statusDes = '未试模'
                    } else if (this.moldTestList[i].status == 1) {
                        this.moldTestList[i].statusDes = 'OK'
                    } else {
                        this.moldTestList[i].statusDes = '不OK'
                    }
                }
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeMoldTest(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        removeMoldTest(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/mold/test/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAllMoldTest()
            })
        },
        pageClick(currentPage){
            
            this.pageIndex=(currentPage-1)*10
            this.getAllOrder(this.statusSearch)
        }
    },
    mounted() {
        this.getAllOrder(this.statusSearch)
    },
    updated() {
        var checkBoxEle = document.getElementsByClassName("el-checkbox")

        checkBoxEle[0].innerHTML = ''

        // console.log(this.gc)
        if (this.gc == 1) {

            this.$refs.moldTable.toggleRowSelection(this.$refs.moldTable.tableData[0])
            this.form.moldCode = this.$refs.moldTable.tableData[0].moldCode
            this.getAllMoldTest()
        }
        this.gc++
    }
}
</script>

<style>
.assembly-header {
    height: 50px;
    line-height: 50px;
    color: orange;
    background-color: #f2f5f6;
    /* box-shadow: 0 0 6px rgba(0, 0, 0, .12); */
    border-radius: 5px;
    border: 1px solid #6f5499;
    margin: 0 0 20px 0;

}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>